const { appConfig } = window;

export default appConfig;
